import { ReactComponent as SettingIcon } from '../../../images/settingNonCircle.svg';
import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    getPublicMaintenanceDisplay,
    hasPublicMaintenanceContent,
} from '../../../utils/publicMachineDisplayUtils';
import '../../../css/machines/chiffreClePart.css';

const PublicMachineChiffreClePart = ({ contract_machine }) => {

    const { t } = useTranslation();

    const labels = {
        company: t('Entreprise :'),
        startDate: t('Date de début de contrat :'),
        endDate: t('Date de fin de contrat :'),
        contact: t('Contact :'),
        phone: t('Téléphone :'),
        email: t('Adresse e-mail :'),
        post: t('Fonction :'),
    };

    if (!hasPublicMaintenanceContent(contract_machine, labels)) {
        return null;
    }

    const { rows, contacts } = getPublicMaintenanceDisplay(contract_machine, labels);

    return (
        <Box className='chiffreClePart_main_box'>
            <Box className='chiffreClePart_cards_Box'>
                <Box className='chiffreClePart_card'>
                    <Box className='chiffreClePart_card_icon_typo_box'>
                        <SettingIcon className='chiffreClePart_icon' />
                        <Typography className='chiffreClePart_text_bold'>{t('Maintenance')}</Typography>
                    </Box>

                    <Box className='chiffreClePart_title_content_box'>
                        <Box className='chiffreClePart_box_typography'>
                            {rows.map((row) => (
                                <Box className='chiffreClePart_response_box' key={row.label}>
                                    <Typography className='chiffreClePart_text_normal'>{row.label}</Typography>
                                    <Typography className='chiffreClePart_text_localisation'>{row.value}</Typography>
                                </Box>
                            ))}
                            {contacts.length > 0 && <Divider />}
                            {contacts.map((fields, index) => (
                                <Box className='chiffreClePart_box_typography' key={index}>
                                    {fields.map((field) => (
                                        <Box className='chiffreClePart_response_box' key={field.label}>
                                            <Typography className='chiffreClePart_text_normal'>{field.label}</Typography>
                                            <Typography className='chiffreClePart_text_localisation'>{field.value}</Typography>
                                        </Box>
                                    ))}
                                    {index < contacts.length - 1 && <Divider sx={{ borderStyle: 'dashed' }} />}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default PublicMachineChiffreClePart;
